export const TODAY = new Date()
const cDay = new Date(TODAY)
cDay.setDate(cDay.getDate() + 1)
export const TOMORROW = cDay
const dDay = new Date(TOMORROW)
dDay.setDate(cDay.getDate() + 1)
export const DAYAFTERTOMORROW = dDay
// Maximum selectable hotel stay length, in nights (check-out - check-in).
export const MAX_STAY_NIGHTS = 28
export const weekday = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]
export const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']